import { createFileRoute } from "@tanstack/react-router";
import { TeamSettings } from "@/components/settings/team-settings";
import { teamMembersQuery, teamRolesQuery } from "@/lib/team-api";
import { warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/settings/team")({
  // A head start on both tabs; the page renders its own skeleton.
  loader: ({ context }) => {
    const orgId = context.auth.session.session.activeOrganizationId ?? null;
    if (!orgId) return;
    warm(context.queryClient.ensureQueryData(teamMembersQuery(orgId)));
    warm(context.queryClient.ensureQueryData(teamRolesQuery(orgId)));
  },
  component: SettingsTeamPage,
});

function SettingsTeamPage() {
  return <TeamSettings />;
}
